import { Preferences } from '@capacitor/preferences';
import { Capacitor } from '@capacitor/core';
import type { StateStorage } from 'zustand/middleware';

async function setItem(name: string, value: string): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    await Preferences.set({ key: name, value });
    return;
  }
  localStorage.setItem(name, value);
}

async function getItem(name: string): Promise<string | null> {
  if (Capacitor.isNativePlatform()) {
    const { value } = await Preferences.get({ key: name });
    return value;
  }
  return localStorage.getItem(name);
}

async function removeItem(name: string): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    await Preferences.remove({ key: name });
    return;
  }
  localStorage.removeItem(name);
}

/** Zustand persist storage that uses Capacitor Preferences on native, localStorage on web. */
export const hybridStorage: StateStorage = {
  getItem: async (name) => getItem(name),
  setItem: async (name, value) => setItem(name, value),
  removeItem: async (name) => removeItem(name),
};

export const preferenceStorage = {
  setItem,
  getItem,
  removeItem,
};
